import type { PageSearch } from './types'

type SearchValue = PageSearch[string]

function scalar(value: unknown): value is string | number | boolean {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean'
}

function searchValue(value: unknown): SearchValue | undefined {
  if (scalar(value)) return value
  if (Array.isArray(value)) {
    const items = value.filter(
      (item): item is string | number => typeof item === 'string' || typeof item === 'number',
    )
    return items.length > 0 ? items : undefined
  }
  return undefined
}

/**
 * A page's validated search params as the panel attaches them to a question:
 * its filters, period, sort and open record (CLAUDE.md §4.5 puts them all in
 * the URL). Only plain values and lists of them; anything else is not a
 * filter the analyst could read. The 2 KB cap is applied when sending.
 */
export function pageSearchOf(search: unknown): PageSearch | undefined {
  if (typeof search !== 'object' || search === null) return undefined
  const out: PageSearch = {}
  for (const [key, value] of Object.entries(search)) {
    const kept = searchValue(value)
    if (kept !== undefined) out[key] = kept
  }
  return Object.keys(out).length > 0 ? out : undefined
}
